export default __webpack_public_path__ + "static/media/img5.fb2768f2.png";